import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// export default new Vuex.Store({
export const store = new Vuex.Store({
  state: {
    currentWiseDay: 51,
    currentUniswapStats: {
      priceETH: -1,
      liquidityETH: -1,
      tokensWISE: -1,
      tokensETH: -1,
      volumeUSD: -1,
      rank: -1
    },
    // uniswapTrading: {
    //   totalVolumeUSD: -1,
    //   totalFeesETH: -1,
    //   totalFeesWISE: -1
    // },
    totalSupply: -1,
    dailySupply: [],
    dailyHolders: [],
    dailyStakers: [],
    topHolders: [],
    topStakers: [],
    topShareHolders: [],
    topReferrers: [],
    totalStaked: -1,
    totalStakedInsurance: -1,
    uniswapBalance: -1,
    holders: -1,
    sharePrice: -1,
    totalShares: -1,
    referralShares: -1,
    investmentsOnAllDays: [],
    supplyOnAllDays: [],
    multipleInvestmentsOnAllDays: [],
    // topReferrers: [],
    allPenalties: [],
    stakeStats: {
      numberStakeStarts: -1,
      numberStakeEnds: -1,
      numberActiveStakes: -1,
      averageStakeLength: -1,
      averageStakeSize: -1,
      weightedAverageStakeLength: -1,
      totalPaiedPenalties: -1
    },
    coingeckoStats: {
      price_usd: -1,
      price_eth: -1,
      change_1h_usd: -1,
      change_1h_eth: -1,
      change_24h_usd: -1,
      change_24h_eth: -1,
      change_7d_usd: -1,
      change_7d_eth: -1,
      change_14d_usd: -1,
      change_14d_eth: -1,
      vol_usd: -1,
      vol_eth: -1,
    },
    currentBlock: 0,
    lastUpdate: null,
    lastUpdateSeconds: -1,
    currentETHPrice: -1,
    totalInvestedETH: -1,
    web3: {
      connected: false,
      web3Instance: null,
      networkId: null,
      account: null,
      balance: null,
    },
    contractInstance: null
  },
  mutations: {
    SET_COINGECKO_STATS(state, coingeckoStats) {
      state.coingeckoStats = coingeckoStats;
    },
    SET_CURRENT_WISE_DAY(state, currentWiseDay) {
      state.currentWiseDay = currentWiseDay;
    },
    SET_CURRENT_UNISWAP_STATS(state, currentUniswapStats) {
      state.currentUniswapStats = currentUniswapStats;
    },
    // SET_UNISWAP_TRADING(state, uniswapTrading) {
    //   state.uniswapTrading = uniswapTrading;
    // },
    SET_TOTAL_SUPPLY(state, totalSupply) {
      state.totalSupply = totalSupply;
    },
    SET_DAILY_SUPPLY(state, dailySupply) {
      state.dailySupply = dailySupply;
    },
    SET_DAILY_HOLDERS(state, dailyHolders) {
      state.dailyHolders = dailyHolders;
    },
    SET_DAILY_STAKERS(state, dailyStakers) {
      state.dailyStakers = dailyStakers;
    },
    SET_TOP_HOLDERS(state, topHolders) {
      state.topHolders = topHolders;
    },
    SET_TOP_STAKERS(state, topStakers) {
      state.topStakers = topStakers;
    },
    SET_TOP_SHAREHOLDERS(state, topShareHolders) {
      state.topShareHolders = topShareHolders;
    },
    SET_TOP_REFERRERS(state, topReferrers) {
      state.topReferrers = topReferrers;
    },
    SET_TOTAL_STAKED(state, totalStaked) {
      state.totalStaked = totalStaked;
    },
    SET_TOTAL_SHARES(state, totalShares) {
      state.totalShares = totalShares;
    },
    SET_REFERRAL_SHARES(state, referralShares) {
      state.referralShares = referralShares;
    },
    SET_TOTAL_STAKED_INSURANCE(state, totalStakedInsurance) {
      state.totalStakedInsurance = totalStakedInsurance;
    },
    SET_HOLDERS(state, holders) {
      state.holders = holders;
    },
    SET_UNISWAP_BALANCE(state, uniswapBalance) {
      state.uniswapBalance = uniswapBalance;
    },
    SET_SHARE_PRICE(state, sharePrice) {
      state.sharePrice = sharePrice;
    },
    SET_INVESTMENTS_ON_ALL_DAYS(state, investmentsOnAllDays) {
      state.investmentsOnAllDays = investmentsOnAllDays;
    },
    SET_SUPPLY_ON_ALL_DAYS(state, supplyOnAllDays) {
      state.supplyOnAllDays = supplyOnAllDays;
    },
    SET_MULTIPLE_INVESTMENTS_ON_ALL_DAYS(state, multipleInvestmentsOnAllDays) {
      state.multipleInvestmentsOnAllDays = multipleInvestmentsOnAllDays;
    },
    SET_CURRENT_ETH_PRICE(state, currentETHPrice) {
      state.currentETHPrice = currentETHPrice;
    },
    // SET_TOP_REFERRERS(state, topReferrers) {
    //   state.topReferrers = topReferrers;
    // },
    SET_ALL_PENALTIES(state, allPenalties) {
      state.allPenalties = allPenalties
    },
    SET_STAKESTATS(state, stakeStats) {
      state.stakeStats = stakeStats
    },
    SET_CURRENT_BLOCK(state, currentBlock) {
      state.currentBlock = currentBlock;
    },
    SET_TOTAL_INVESTED_ETH(state, totalInvestedETH) {
      state.totalInvestedETH = totalInvestedETH;
    },
    SET_LAST_UPDATE(state, lastUpdate) {
      state.lastUpdate = lastUpdate;
    },
    SET_LAST_UPDATE_SECONDS(state, lastUpdateSeconds) {
      state.lastUpdateSeconds = lastUpdateSeconds;
    },
    SET_WEB3OBJECT(state, web3Object) {
      state.web3 = web3Object;
    },
  },
  actions: {},
  modules: {}
});
